import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import PropTypes from "prop-types";
import { Row, Col, Form, Space, Input, Spin, Tooltip } from "antd";
import { MinusSquareFilled, PlusSquareFilled } from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";

const BillingSiteLocationKeyPerson = ({ state, setState, companyId, data }) => {
  const formRef = useRef();
  const { t } = useTranslation();
  const colors = ["#0000"];
  const [apiLoading, setapiloading] = useState(false);

  const handleCloneInputChange = (field, e, index) => {
    let newPersonArr = state.delivery_address_billing_keypersons;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, delivery_address_billing_keypersons: newPersonArr });
  };
  const removePerson = async (lastIndex) => {
    let filterPersonArr = state.delivery_address_billing_keypersons.filter(
      (item, index) => index !== lastIndex
    );
    setState({
      ...state,
      delivery_address_billing_keypersons: filterPersonArr,
    });
    setWeightSizeFieldValue(filterPersonArr);
  };

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["persons_name" + objectKey] = objectValue.persons_name;
      fieldObject["email" + objectKey] = objectValue.email;
      fieldObject["mobile_number" + objectKey] = String(
        objectValue.mobile_number || "+91"
      );
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };
  const addPerson = () => {
    let newPersonArr = [
      ...state.delivery_address_billing_keypersons,
      {
        persons_name: null,
        email: null,
        mobile_number: null,
      },
    ];
    setState({ ...state, delivery_address_billing_keypersons: newPersonArr });
    setWeightSizeFieldValue(newPersonArr);
  };
  const handleClonePhoneInputChange = (field, phone, index) => {
    let newPersonArr = state.delivery_address_billing_keypersons;
    newPersonArr[index][field] = phone ? phone : null;
    setState({ ...state, delivery_address_billing_keypersons: newPersonArr });
  };

  // const phoneValidLength = state.phone;

  // const validatePhoneNumber = () => {
  //   if (
  //     (phoneValidLength && phoneValidLength.length < 8) ||
  //     phoneValidLength === null ||
  //     phoneValidLength === ""
  //   ) {
  //     return Promise.reject(new Error(t("please_enter_valid_phone")));
  //   }

  //   return Promise.resolve();
  // };

  useEffect(() => {
    if (companyId) {
      const modifiedInquiry = state.delivery_address_billing_keypersons.map(
        (inquiryDetail) => {
          const { id, company, company_name, ...rest } = inquiryDetail;
          return rest;
        }
      );

      setWeightSizeFieldValue(modifiedInquiry);
    }
  }, [state, companyId, t]);

  return (
    <>
      {/* <section className="grid-sec FormSection Container">
        <div className="FormBody"> */}
      <Col xs={24} xl={24}>
        <Spin spinning={apiLoading}>
          <Form onFinish={""} autoComplete="off" ref={formRef}>
            {state.delivery_address_billing_keypersons &&
              state.delivery_address_billing_keypersons.map((x, index) => {
                return (
                  <>
                   
                    <Row key={index} className="customcol" gutter={[15]}>
                      <Col xs={20} >
                      <Row  gutter={[15]}>
                      <Col xs={24} sm={12} xl={12} xxl={8}>
                        <Form.Item
                          name={`persons_name` + index}
                          label={t("pl_personName")}
                          rules={[
                            {
                              required: index === 0, // Only first person is required
                              message: <Trans>Please enter person name</Trans>,
                            },
                            {
                              pattern: /^[a-zA-Z_ ]+$/,
                              message: "Enter valid name",
                            },
                            {
                              min: 2,
                              message: <Trans>{t("minlength_msg")}</Trans>,
                            },
                            {
                              max: 15,
                              message: (
                                <Trans>{t("maxlength_personName")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("place_personName")}
                            onChange={(value) =>
                              handleCloneInputChange(
                                "persons_name",
                                value,
                                index
                              )
                            }
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} xl={12} xxl={8}>
                        <Form.Item
                          name={`email` + index}
                          label={t("lbb_email")}
                          rules={[
                            {
                              type: "email",
                              message: <Trans>{t("val_email")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("place_email")}
                            onChange={(value) =>
                              handleCloneInputChange("email", value, index)
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} xl={24} xxl={8}>
                        <Form.Item
                          name={`mobile_number` + index}
                          label={t("pl_mobile_number")}
                          pattern={"/^d{12}$/"}
                          rules={[
                            {
                              message: <Trans>{t("val_phone")}</Trans>,
                            },
                            {
                              pattern: /^\d{12}$/,
                              message: <Trans>{t("val_phone")}</Trans>,
                            },
                          ]}
                        >
                          <PhoneInput
                            country={"in"}
                            onChange={(phone) =>
                              handleClonePhoneInputChange(
                                "mobile_number",
                                phone,
                                index
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                    
                    </Row>
                      </Col>
                      <Col xs={4} >
                      <div className="addwrp">
                          <Space>
                            {index !== 0 ? (
                              <Tooltip
                                color={colors}
                                title={
                                  <span style={{ color: "#000000" }}>
                                    Remove Person
                                  </span>
                                }
                              >
                                <MinusSquareFilled
                                  className="add"
                                  onClick={() => removePerson(index)}
                                />{" "}
                              </Tooltip>
                            ) : (
                              ""
                            )}

                            {state.delivery_address_billing_keypersons.length <
                            3 ? (
                              <>
                                <Tooltip
                                  color={colors}
                                  title={
                                    <span style={{ color: "#000000" }}>
                                      Add Person
                                    </span>
                                  }
                                >
                                  {/* {index <2  ? */}
                                  <PlusSquareFilled
                                    className="add"
                                    onClick={(e) => addPerson(e)}
                                  />
                                  {/* : ''} */}
                                </Tooltip>
                              </>
                            ) : (
                              ""
                            )}
                          </Space>
                        </div>
                      </Col>
                    </Row>
                  </>
                );
              })}
          </Form>
        </Spin>
      </Col>
      {/* </div>
      </section> */}
    </>
  );
};
BillingSiteLocationKeyPerson.propTypes = {
  state: PropTypes.func,
  setState: PropTypes.func,
  companyId: PropTypes.number,
  data: PropTypes.func,
};
export default BillingSiteLocationKeyPerson;
